<template>
  <div class="app-container">
    <el-tabs v-model="active" @tab-click="handleClick" type="card" class="cardTabs">
      <el-tab-pane label="丘成桐少年班六年级" name="0"></el-tab-pane>
      <el-tab-pane label="丘成桐少年班、信息特长生初三年级" name="1"></el-tab-pane>
    </el-tabs>
    <list ref="list" v-if="active==0">
      <template slot="toolbar-right">
        <template v-if="$permission.canWrite()">
          <el-button type="success" @click="updateStatus('list',3)">审核通过</el-button>
          <el-button type="danger" @click="updateStatus('list',2)">审核不通过</el-button>
          <el-button type="warning" @click="updateStatus('list',11)">撤销审核</el-button>
        </template>
        <el-button type="success" @click="toExport('list','export')" plain>导出</el-button>
        <el-button type="success" @click="toExport('list','exportInfo')" plain>导出信息表</el-button>
      </template>
      <template slot="column">
        <el-table-column label="操作" fixed="right" align="center" width="210">
          <template slot-scope="{row}">
            <el-button type="text" @click="detailsById(row.Junior6Id)">查看</el-button>
            <el-button type="text" @click="print2(row.Junior6Id)" :disabled="row.Status!=3">打印遴选证</el-button>
            <el-button type="text" @click="print(row.Junior6Id)" :disabled="row.Status!=3">打印报名信息</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <list2 ref="list2" v-if="active==1">
      <template slot="toolbar-right">
        <template v-if="$permission.canWrite()">
          <el-button type="success" @click="updateStatus('list2',3)">审核通过</el-button>
          <el-button type="danger" @click="updateStatus('list2',2)">审核不通过</el-button>
          <el-button type="warning" @click="updateStatus('list2',11)">撤销审核</el-button>
        </template>
        <el-button type="success" @click="toExport('list2','export')" plain>导出</el-button>
        <el-button type="success" @click="toExport('list2','exportInfo')" plain>导出信息表</el-button>
      </template>
      <template slot="column">
        <el-table-column label="操作" fixed="right" align="center" width="210">
          <template slot-scope="{row}">
            <el-button type="text" @click="detailsById2(row.Junior9Id)">查看</el-button>
            <el-button type="text" @click="print9_2(row.Junior9Id)" :disabled="row.Status!=3">打印准考证</el-button>
            <el-button type="text" @click="print9(row.Junior9Id)" :disabled="row.Status!=3">打印报名信息</el-button>
          </template>
        </el-table-column>
      </template>
    </list2>
    <view-dialog ref="viewDialog" @close-saved="reload" />
    <view-dialog2 ref="viewDialog2" @close-saved="reload" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/po/poreview/list";
import list2 from "@/components/po/poreview/list2";
import viewDialog from "@/components/po/poreview/viewDialog";
import viewDialog2 from "@/components/po/poreview/viewDialog2";

export default {
  name: "",
  mixins: [curdMixins],
  components: {
    list,
    list2,
    viewDialog,
    viewDialog2
  },
  data() {
    return {
      api: require("@/api/po/junior6").default,
      api2: require("@/api/po/junior9").default,
      active: "0",
      last: -1,
      isMB: this.$store.state.isMB,
    }
  },
  methods: {
    reload() {
      this.handleClick(this.active);
    },
    handleClick(e) {
      setTimeout(() => {
        if(this.active=='0') {
          this.$refs.list.reload();
        } else if(this.active=='1') {
          this.$refs.list2.reload();
        }
      }, 200);
    },
    detailsById(id) {
      this.$refs.viewDialog.openDetailsById(id);
    },
    detailsById2(id) {
      this.$refs.viewDialog2.openDetailsById(id);
    },
    updateStatus(ref,Status) {
      let rows = this.$refs[ref].getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要操作的数据");
        return;
      }
      this.$confirm("确认操作吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let Ids = rows.map((item) => {
            return ref=="list"?item.Junior6Id:item.Junior9Id;
          });
          var name = ref=="list"?"api":"api2";
          this[name].updateStatus({ Ids, Status }).then(res => {
            if(res.Code==0) {
              this.$refs[ref].reload();
              this.$message.success(res.Msg);
            } else this.$message.error(res.Msg);
          })
        })
        .catch(() => {});
    },
    toExport(ref,name) {
      this.$refs[ref].toExport(name);
    },
    print(id) {
      let newpage = this.$router.resolve({
        path: '/print6?id=' + id
      })
      window.open(newpage.href, '_blank'); 
    },
    print2(id) {
      let newpage = this.$router.resolve({
        path: '/print6_2?id=' + id
      })
      window.open(newpage.href, '_blank'); 
    },
    print9(id) {
      let newpage = this.$router.resolve({
        path: '/print9?id=' + id
      })
      window.open(newpage.href, '_blank'); 
    },
    print9_2(id) {
      let newpage = this.$router.resolve({
        path: '/print9_2?id=' + id
      })
      window.open(newpage.href, '_blank'); 
    },
  }
};
</script>